var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"space-around"}},[_c('v-col',{staticClass:"col-12 d-flex justify-center header-2 page-header"},[_vm._v(" "+_vm._s(_vm.formTitle)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }